import { isControlFreemium, isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { sendDwh } from 'reactApp/utils/ga';

export const getFreemiumHeavyFileAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_hard_freemium_heavy';
    }
    if (isSoftFreemium) {
        return 'mnz_family_soft_freemium_heavy';
    }
    if (isControlFreemium) {
        return 'mnz_family_trial_freemium_heavy';
    }
    return 'mnz_family_freemium_heavy_none';
};

export const sendFreemiumHeavyFileDwh = (action: 'show' | 'close' | 'click' | 'show-more', name: string) => {
    sendDwh({
        eventCategory: 'modal',
        action,
        dwh_enabled: true,
        dwhData: {
            name,
        },
    });
};
